import { render, staticRenderFns } from "./TwProcessGroupListPreviewLcTable.vue?vue&type=template&id=6c6fe727&scoped=true&"
import script from "./TwProcessGroupListPreviewLcTable.vue?vue&type=script&lang=js&"
export * from "./TwProcessGroupListPreviewLcTable.vue?vue&type=script&lang=js&"
import style0 from "./TwProcessGroupListPreviewLcTable.vue?vue&type=style&index=0&id=6c6fe727&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6fe727",
  null
  
)

export default component.exports